import {Component, OnInit, ViewEncapsulation} from '@angular/core';

import {ActivatedRoute, NavigationEnd, Router, RouterEvent} from '@angular/router';
import {UserHelpService} from '../../service/user-help.service';
import {filter} from 'rxjs/operators';

@Component({
    selector: 'ngc-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HelpComponent implements OnInit {

    public helpItems: any[];

    constructor(
                private userHelpService: UserHelpService,
                private router: Router,
                private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit() {
        this.helpItems = this.getHelpItems();

        this.router.events
            .pipe(filter((event: RouterEvent) => event instanceof NavigationEnd))
            .subscribe((event) => {
                this.helpItems = this.getHelpItems();
            }
            );
    }

    getHelpItems() {
        const fullPath: string = this.userHelpService.getStringFullParameterisedPath(this.activatedRoute);

        return this.userHelpService.getQuestions(fullPath);
    }
}
